import {
  FinancialAccountSortOption,
  FinancialAccountType,
} from '@rematter/frontend-lib-api-client';

import { toMoney } from '~/modules/trade/utils/money';
import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

type Args = {
  searchTerm?: string;
  types?: FinancialAccountType[];
  currencies?: string[];
  visibleInPayments?: boolean;
  limit?: number;
  offset?: number;
  sorting: FinancialAccountSortOption[];
};

export const financialAccountsQueryAtom = createQueryAtomFactory(
  'finance.financialAccounts',
  (params: Args) => ({
    financialAccounts: {
      __args: {
        filter: {
          searchTerm: params.searchTerm,
          types: params.types,
          currencies: params.currencies,
          visibleInPayments: params.visibleInPayments,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 10,
        },
        sorting: params.sorting,
      },
      entries: {
        __scalar: true,
        name: true,
        type: true,
        currentBalance: {
          __scalar: true,
        },
        currency: true,
        visibleInPayments: true,
        linked: true,
        roundingMethod: true,
        roundingPrecision: true,
        facility: {
          id: true,
          facilityName: true,
        },
        nachaCompanyIdentification: true,
        nachaCompanyName: true,
        nachaDefaultSecCode: true,
        paymentAllocationMethod: true,
        timestamps: {
          createdAt: true,
          updatedAt: true,
        },
      },
      page: {
        total: true,
      },
    },
  }),
  {
    select: (data) => ({
      accounts: data?.financialAccounts.entries.map((it) => ({
        id: it.id,
        name: it.name,
        type: it.type,
        currentBalance: toMoney(it.currentBalance),
        currency: it.currency,
        visibleInPayments: it.visibleInPayments,
        linked: it.linked,
        roundingMethod: it.roundingMethod,
        roundingPrecision: it.roundingPrecision,
        facilityId: it.facility.id,
        facilityName: it.facility.facilityName,
        nachaCompanyIdentification: it.nachaCompanyIdentification,
        nachaCompanyName: it.nachaCompanyName,
        nachaDefaultSecCode: it.nachaDefaultSecCode,
        paymentAllocationMethod: it.paymentAllocationMethod,
        createdAt: new Date(it.timestamps.createdAt),
        updatedAt: new Date(it.timestamps.updatedAt),
      })),
      total: data?.financialAccounts.page.total,
    }),
  },
);
